export default __webpack_public_path__ + "static/media/FilterAltFilled.35c3a685.svg";